import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Receipt } from "lucide-react";

const EventManagementExpenses: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground flex items-center gap-2">
          <Receipt className="h-6 w-6 text-secondary" />
          Expenses
        </h1>
        <p className="text-muted-foreground mt-1">Track and categorize event expenses and budgets.</p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center justify-between">Expense Tracking <Badge variant="secondary">Coming Soon</Badge></CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">Log expenses, categorize costs, set budgets per event, and generate financial reports.</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default EventManagementExpenses;
